export class ClientDetails {
    clientId: number | null = null;
    clientName: string | null = null;
    defaultCompanyName: string | null = null;
    defaultCompanyLogo: string | null = null;
    paymentMode: string | null = null; //1->PayNow, 2->PayLater, 3->Both
    theme:string | null = null  ;//green-light, orange-light
  }
  